// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16yoH {\n  width: 100%;\n  margin-top: 96px;\n  margin-top: 6rem;\n  min-height: 60vh;\n  padding: 0px 0 64px;\n  padding: 0rem 0 4rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  color: white;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n@media screen and (min-width: 1024px) {\n  ._16yoH {\n    padding: 6rem 1.6rem 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"container_lazyload": "_16yoH"
};
module.exports = exports;
